<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('首頁') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('教職員工借用職務宿舍申請表') }}</li>
      </ol>
    </nav>
    <div class="wrapper form form_1" v-if="ApplyData && ApplyData.Apply">
      <svg class="bg"></svg>
      <div class="container">
        <div class="box_bg">
          <div class="title_box">
            <h1>{{ $t('教職員工借用職務宿舍申請表') }}</h1>
            <button class="open_btn" @click="showPhoto()">{{ $t('流程圖') }} <span>＋</span></button>
          </div>
          <div class="process_box">
            <img src="img/img_8.png" alt="">
          </div>
          <div class="title">
            <h2>{{ $t('申請宿舍類別（單選）') }}</h2>
          </div>
          <div class="check_box">
            <div>
              <p class="text">{{ $t('多房間職務宿舍') }} <span>{{ $t('（水、電及瓦斯等自付）') }}</span></p>
              <div class="form-check" v-for="(StaffLevel, index) in ApplyData.SharedRooms" :key="index">
                <input class="form-check-input" type="radio" :id="'T1_SLId_' + StaffLevel.SLId"
                  v-bind:value="StaffLevel.SLId" v-model="ApplyData.Apply.T1_SLId">
                <label class="form-check-label" :for="'T1_SLId_' + StaffLevel.SLId">
                  {{ local == "zh_tw" ? StaffLevel.Name : StaffLevel.Name_EN }} {{ numberToCurrencyNo(StaffLevel.Price)
                  }}{{ $t('元/月') }}　{{ $t('保證金') }}{{
                    numberToCurrencyNo(StaffLevel.Deposit) }}{{ $t('元') }}
                </label>
              </div>
            </div>
            <div>
              <p class="text">{{ $t('單房間職務宿舍') }} <span>{{ $t('（應付水電1,512元/月）') }}</span></p>
              <div class="form-check" v-for="(StaffLevel, index) in ApplyData.SingleRooms" :key="index">
                <input class="form-check-input" type="radio" :id="'T1_SLId_' + StaffLevel.SLId"
                  v-bind:value="StaffLevel.SLId" v-model="ApplyData.Apply.T1_SLId">
                <label class="form-check-label" :for="'T1_SLId_' + StaffLevel.SLId">
                  {{ local == "zh_tw" ? StaffLevel.Name : StaffLevel.Name_EN }} {{ numberToCurrencyNo(StaffLevel.Price)
                  }}{{ $t('元/月') }}　{{ $t('保證金') }}{{
                    numberToCurrencyNo(StaffLevel.Deposit) }}{{ $t('元') }}
                </label>
              </div>
            </div>
          </div>
          <p><a href="/#/Post/296" target="_blank">{{ $t('（請參閱本校教職員工宿舍分配要點）') }}</a></p>
          <div class="title">
            <h2>服務單位</h2>
          </div>
          <div class="box">
            <div class="form-group">
              <label>{{ $t('名稱') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_UnitName" data-required="1"
                :data-required-msg="$t('請輸入名稱')" aria-describedby="" :placeholder="$t('請輸入名稱')">
            </div>
            <div class="form-group">
              <label>{{ $t('到校日') }}</label>
              <input type="date" class="form-control" v-model="ApplyData.Apply.T1_UnitArrivalDate" data-required="1"
                :data-required-msg="$t('請輸入到校日')" aria-describedby="" :placeholder="$t('請輸入到校日')" disabled>
            </div>
            <div class="form-group">
              <label>{{ $t('電話') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_UnitPhone" data-required="1"
                :data-required-msg="$t('請輸入電話')" aria-describedby="" :placeholder="$t('請輸入電話')">
            </div>
            <div class="form-group">
              <label>{{ $t('員工代號') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_UnitEmployeeID" data-required="1"
                :data-required-msg="$t('請輸入員工代號')" aria-describedby="" :placeholder="$t('請輸入員工代號')" disabled>
            </div>
            <div class="form-group">
              <label>{{ $t('職稱') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_UnitPosition" data-required="1"
                :data-required-msg="$t('請輸入職稱')" aria-describedby="" :placeholder="$t('請輸入職稱')">
            </div>
            <!-- 20240904 修改欄位  -->
            <div class="form-group">
              <label>{{ $t('兼任本校行政主管職層級') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_AdminSupervisorLevel"
                data-required="1" :data-required-msg="$t('請輸入兼任本校行政主管職層級')" aria-describedby=""
                :placeholder="$t('請輸入兼任本校行政主管職層級')">
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('申請人') }}</h2>
          </div>
          <div class="box">
            <div class="form-group">
              <label>{{ $t('姓名') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_ApplicantName" data-required="1"
                :data-required-msg="$t('請輸入姓名')" aria-describedby="" :placeholder="$t('請輸入姓名')" disabled>
            </div>
            <!--<div class="form-group">
              <label>{{ $t('身分證號碼或護照') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_ApplicantIDorPassport"
                data-required="1" :data-required-msg="$t('請輸入身分證號碼或護照')" aria-describedby=""
                :placeholder="$t('請輸入身分證號碼或護照')" disabled>
            </div>-->
            <div class="form-group">
              <label>{{ $t('性別') }}</label>
              <div class="check">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T1_ApplicantGender_M" v-bind:value="'男'"
                    v-model="ApplyData.Apply.T1_ApplicantGender" disabled>
                  <label class="form-check-label" for="T1_ApplicantGender_M">
                    {{ $t('男') }}
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T1_ApplicantGender_F" v-bind:value="'女'"
                    v-model="ApplyData.Apply.T1_ApplicantGender" disabled>
                  <label class="form-check-label" for="T1_ApplicantGender_F">
                    {{ $t('女') }}
                  </label>
                </div>
              </div>
            </div>
            <!--<div class="form-group">
              <label>{{ $t('出生年月日') }}</label>
              <input type="date" class="form-control" v-model="ApplyData.Apply.T1_ApplicantBirthDate" data-required="1"
                :data-required-msg="$t('請輸入出生年月日')" aria-describedby="" :placeholder="$t('請輸入出生年月日')" disabled>
            </div>-->
            <div class="form-group">
              <label>{{ $t('職務') }}</label>
              <!-- <select class="form-control" v-model="ApplyData.Apply.T1_ApplicantPosition">
                <option selected disabled>請選擇</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
              </select> -->
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_ApplicantPosition" data-required="1"
                :data-required-msg="$t('請輸入職務')" aria-describedby="" :placeholder="$t('請輸入職務')">
            </div>
            <div class="form-group">
              <label>{{ $t('電子信箱') }}</label>
              <input type="email" class="form-control" v-model="ApplyData.Apply.T1_ApplyEmail" data-required="1"
                :data-required-msg="$t('請輸入電子信箱')" aria-describedby="" :placeholder="$t('請輸入電子信箱')">
            </div>
            <div class="form-group" style="flex-wrap: wrap;">
              <label>{{ $t('中華民國身心障礙手冊') }}<span style="color: red;"
                  v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.T1_DisabilityCertificate">
                  {{ $t('(已上傳, 可更新)') }}</span></label>
              <div class="custom_file form-control">
                <input type="file" id="T1_DisabilityCertificate"
                  accept=".zip,.rar,.7z,.bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T1_DisabilityCertificate_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.T1_DisabilityCertificate"
                  id="T1_DisabilityCertificate_data" />
                <label class="" for="T1_DisabilityCertificate">{{ $t('上傳檔案') }}</label>
              </div>
              <small class="form-text text-muted" style="margin-top: 5px; color: #6c757d; font-size: 0.875rem;">
                <div>{{ $t('支援格式') }}</div>
                <div>{{ $t('檔案大小限制') }}</div>
              </small>
            </div>
            <hr class="line">
            <div class="form-group full residence_box">
              <label for="">{{ $t('自有住宅狀況') }}</label>
              <div class="residence">
                <label>{{ $t('自有住宅') }}</label>
                <div class="check">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="T1_OwnHouse_Y" v-bind:value="1"
                      v-model="ApplyData.Apply.T1_OwnHouse">
                    <label class="form-check-label" for="T1_OwnHouse_Y">
                      {{ $t('有') }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="T1_OwnHouse_N" v-bind:value="0"
                      v-model="ApplyData.Apply.T1_OwnHouse">
                    <label class="form-check-label" for="T1_OwnHouse_N">
                      {{ $t('無') }}
                    </label>
                  </div>
                </div>
                <hr class="line">
                <label>{{ $t('本人或配偶已有自有住宅或自申請分配宿舍之日起，逆算至最近3年內曾有屬於其本人或配偶所有之房屋買賣或贈與紀錄者。') }}</label>
                <div class="check">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="T1_OwnHouseSpouse_Y" v-bind:value="1"
                      v-model="ApplyData.Apply.T1_OwnHouseSpouse">
                    <label class="form-check-label" for="T1_OwnHouseSpouse_Y">
                      {{ $t('是') }}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="T1_OwnHouseSpouse_N" v-bind:value="0"
                      v-model="ApplyData.Apply.T1_OwnHouseSpouse">
                    <label class="form-check-label" for="T1_OwnHouseSpouse_N">
                      {{ $t('否') }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <hr class="line">
            <div class="form-group full">
              <label>{{ $t('戶籍地址') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T1_ResidentialAddress" data-required="1"
                :data-required-msg="$t('請輸入戶籍地址')" aria-describedby="" :placeholder="$t('請輸入戶籍地址')">
            </div>
            <div class="form-group" style="flex-wrap: wrap;">
              <label>{{ $t('全戶戶籍謄本上傳') }}<span style="color: red;"
                  v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.T1_ResidentCopy">
                  {{ $t('(已上傳, 可更新)') }}</span></label>
              <div class="custom_file form-control">
                <input type="file" id="T1_ResidentCopy"
                  accept=".zip,.rar,.7z,.bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T1_ResidentCopy_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.T1_DisabilityCertificate" id="T1_ResidentCopy_data" />
                <label class="" for="T1_ResidentCopy">{{ $t('上傳檔案') }}</label>
              </div>
              <small class="form-text text-muted" style="margin-top: 5px; color: #6c757d; font-size: 0.875rem;">
                <div>{{ $t('支援格式') }}</div>
                <div>{{ $t('檔案大小限制') }}</div>
              </small>
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('隨居任所者親屬資料（申請單房間者免填）') }}</h2>
          </div>
          <div class="box">
            <ul class="list">
              <li class="title">
                <div class="form-group">
                  <label>{{ $t('稱謂') }}</label>
                </div>
                <div class="form-group">
                  <label>{{ $t('姓名') }}</label>
                </div>
                <div class="form-group">
                  <label>{{ $t('出生年月日') }}</label>
                </div>
                <div class="form-group">
                  <label>{{ $t('身分證統一編號') }}</label>
                </div>
                <div class="form-group">
                  <label>{{ $t('職業及服務單位') }}</label>
                </div>
                <button class="new_btn" @click="addResidentRelativeInfo()">{{ $t('新增') }}</button>
              </li>
              <li class="main" v-for="(ResidentRelativeInfo, index) in ResidentRelativeInfos" :key="index">
                <div class="form-group">
                  <label>{{ $t('稱謂') }}</label>
                  <input type="text" class="form-control" v-model="ResidentRelativeInfo.Title" data-required="1"
                    :data-required-msg="$t('請輸入稱謂')" aria-describedby="" :placeholder="$t('請輸入稱謂')">
                </div>
                <div class="form-group">
                  <label>{{ $t('姓名') }}</label>
                  <input type="text" class="form-control" v-model="ResidentRelativeInfo.Name" data-required="1"
                    :data-required-msg="$t('請輸入姓名')" aria-describedby="" :placeholder="$t('請輸入姓名')">
                </div>
                <div class="form-group">
                  <label>{{ $t('出生年月日') }}</label>
                  <input type="date" class="form-control" v-model="ResidentRelativeInfo.BirthDate" data-required="1"
                    :data-required-msg="$t('請輸入出生年月日')" aria-describedby="" :placeholder="$t('請輸入出生年月日')">
                </div>
                <div class="form-group">
                  <label>{{ $t('身分證統一編號') }}</label>
                  <input type="text" class="form-control" v-model="ResidentRelativeInfo.IDNumber" data-required="1"
                    :data-required-msg="$t('請輸入身分證統一編號')" aria-describedby="" :placeholder="$t('請輸入身分證統一編號')">
                </div>
                <div class="form-group">
                  <label>{{ $t('職業及服務單位') }}</label>
                  <input type="text" class="form-control" v-model="ResidentRelativeInfo.OccupationAndUnit"
                    data-required="1" :data-required-msg="$t('請輸入職業及服務單位')" aria-describedby=""
                    :placeholder="$t('請輸入職業及服務單位')">
                </div>
                <button class="cancel_btn" @click="removeResidentRelativeInfo(index)">{{ $t('刪除') }}</button>
              </li>
            </ul>
          </div>
          <!-- 20240909 原推薦信 修改新增 -->
          <div class="title">
            <h2>{{ $t('職務上有迫切需要') }}</h2>
          </div>
          <div class="box">
            <div class="form-group need_box full">
              <label>{{ $t('職務上有迫切需要') }}</label>
              <div class="check">
                <div class="form-check need_check">
                  <input class="form-check-input" type="radio" id="T1_UrgentJobNeed_N" v-bind:value="false"
                    v-model="ApplyData.Apply.T1_UrgentJobNeed">
                  <label class="form-check-label" for="T1_UrgentJobNeed_N">
                    {{ $t('否') }}
                  </label>
                </div>
                <div class="form-check need_check">
                  <input class="form-check-input" type="radio" id="T1_UrgentJobNeed_Y" v-bind:value="true"
                    v-model="ApplyData.Apply.T1_UrgentJobNeed">
                  <label class="form-check-label" for="T1_UrgentJobNeed_Y">
                    {{ $t('是') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group need_file" style="display: flex; flex-wrap: wrap;" v-if="ApplyData.Apply.T1_UrgentJobNeed">
              <label>{{ $t('服務單位主管副署') }}<span style="color: red;"
                  v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.T1_UnitSupervisorSignature">
                  {{ $t('(已上傳, 可更新)') }}</span></label>
              <div class="custom_file form-control">
                <input type="file" id="T1_UnitSupervisorSignature"
                  accept=".zip,.rar,.7z,.bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T1_UnitSupervisorSignature_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.T1_DisabilityCertificate"
                  id="T1_UnitSupervisorSignature_data" />
                <label class="" for="T1_UnitSupervisorSignature">{{ $t('上傳檔案') }}</label>
              </div>
              <small class="form-text text-muted" style="margin-top: 5px; color: #6c757d; font-size: 0.875rem;">
                <div>{{ $t('支援格式') }}</div>
                <div>{{ $t('檔案大小限制') }}</div>
              </small>
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('申請人具結聲明') }}</h2>
          </div>
          <div class="box">
            <p class="text">
              {{
                $t('本人具結自申請日前，本人及配偶絕無經政府輔購（建）住宅或貸款，並保證借住期間，絕對遵守學校規定、不轉借、不轉租、不空置，並保持環境之整潔、安寧與秩序，如違反上述規定，願負一切法律責任，並立即交還宿舍')
              }}
            </p>
          </div>
          <template
            v-if="(local == 'zh_tw' && ApplyData.apply_1_need_tw) || (local == 'en' && ApplyData.apply_1_need_en)">
            <div class="title">
              <h2>{{ $t('閱讀須知') }}</h2>
            </div>
            <div class="box">
              <div class="instructions-content" @scroll="handleScroll" ref="instructionsContent">
                <div v-html="local == 'zh_tw' ? ApplyData.apply_1_need_tw : ApplyData.apply_1_need_en">
                </div>
              </div>
              <div class="instructions-checkbox-container">
                <div class="form-check instructions_check" style="font-size: 1.1rem;">
                  <input class="form-check-input" type="checkbox" v-model="instructions_check" id="flexCheckDefault"
                    :disabled="!scrolledToBottom">
                  <label class="form-check-label" for="flexCheckDefault">
                    {{ $t('我已閱讀條款') }}
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="btn_box">
          <button class="send_box" @click="send()">{{ $t('送出') }}</button>
        </div>
      </div>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "教職員工借用職務宿舍申請表": "教職員工借用職務宿舍申請表",
    "流程圖": "流程圖",
    "申請宿舍類別（單選）": "申請宿舍類別（單選）",
    "多房間職務宿舍": "多房間職務宿舍",
    "（水、電及瓦斯等自付）": "（水、電及瓦斯等自付）",
    "元/月": "元/月",
    "保證金": "保證金",
    "元": "元",
    "單房間職務宿舍": "單房間職務宿舍",
    "（應付水電1,512元/月）": "（應付水電1,512元/月）",
    "（請參閱本校教職員工宿舍分配要點）": "（請參閱本校教職員工宿舍分配要點）",
    "名稱": "名稱",
    "請輸入名稱": "請輸入名稱",
    "到校日": "到校日",
    "請輸入到校日": "請輸入到校日",
    "電話": "電話",
    "請輸入電話": "請輸入電話",
    "員工代號": "員工代號",
    "請輸入員工代號": "請輸入員工代號",
    "職稱": "職稱",
    "請輸入職稱": "請輸入職稱",
    "兼任本校行政主管職層級": "兼任本校行政主管職層級",
    "請輸入兼任本校行政主管職層級": "請輸入兼任本校行政主管職層級",
    "申請人": "申請人",
    "姓名": "姓名",
    "請輸入姓名": "請輸入姓名",
    "身分證號碼或護照": "身分證號碼或護照",
    "請輸入身分證號碼或護照": "請輸入身分證號碼或護照",
    "性別": "性別",
    "男": "男",
    "女": "女",
    "出生年月日": "出生年月日",
    "請輸入出生年月日": "請輸入出生年月日",
    "職務": "職務",
    "請輸入職務": "請輸入職務",
    "中華民國身心障礙手冊": "中華民國身心障礙手冊",
    "(已上傳, 可更新)": "(已上傳, 可更新)",
    "上傳檔案": "上傳檔案",
    "支援格式": "支援格式：ZIP、RAR、7Z、BMP、JPG、GIF、TIF、PNG、JPEG、ODT、DOC、DOCX、PDF、TXT",
    "檔案大小限制": "檔案大小限制：100MB",
    "自有住宅狀況": "自有住宅狀況",
    "自有住宅": "自有住宅",
    "有": "有",
    "無": "無",
    "本人或配偶已有自有住宅或自申請分配宿舍之日起，逆算至最近3年內曾有屬於其本人或配偶所有之房屋買賣或贈與紀錄者。": "本人或配偶已有自有住宅或自申請分配宿舍之日起，逆算至最近3年內曾有屬於其本人或配偶所有之房屋買賣或贈與紀錄者。",
    "是": "是",
    "否": "否",
    "戶籍地址": "戶籍地址",
    "請輸入戶籍地址": "請輸入戶籍地址",
    "全戶戶籍謄本上傳": "全戶戶籍謄本上傳",
    "隨居任所者親屬資料（申請單房間者免填）": "隨居任所者親屬資料（申請單房間者免填）",
    "稱謂": "稱謂",
    "身分證統一編號": "身分證統一編號",
    "職業及服務單位": "職業及服務單位",
    "新增": "新增",
    "請輸入稱謂": "請輸入稱謂",
    "請輸入身分證統一編號": "請輸入身分證統一編號",
    "請輸入職業及服務單位": "請輸入職業及服務單位",
    "刪除": "刪除",
    "職務上有迫切需要": "職務上有迫切需要",
    "服務單位主管副署": "服務單位主管副署",
    "申請人具結聲明": "申請人具結聲明",
    "本人具結自申請日前，本人及配偶絕無經政府輔購（建）住宅或貸款，並保證借住期間，絕對遵守學校規定、不轉借、不轉租、不空置，並保持環境之整潔、安寧與秩序，如違反上述規定，願負一切法律責任，並立即交還宿舍": "本人具結自申請日前，本人及配偶絕無經政府輔購（建）住宅或貸款，並保證借住期間，絕對遵守學校規定、不轉借、不轉租、不空置，並保持環境之整潔、安寧與秩序，如違反上述規定，願負一切法律責任，並立即交還宿舍",
    "送出": "送出",
    "請先登入帳號": "請先登入帳號",
    "請稍候...": "請稍候...",
    "錯誤": "錯誤",
    "確定": "確定",
    "Email格式錯誤": "Email格式錯誤",
    "數字不可小於0": "數字不可小於0",
    "請選擇申請宿舍類別": "請選擇申請宿舍類別",
    "請選擇性別": "請選擇性別",
    "請選擇自有住宅狀況": "請選擇自有住宅狀況",
    "請上傳服務單位主管副署": "請上傳服務單位主管副署",
    "儲存成功": "儲存成功",
    "檔案大小超過100MB": "檔案大小超過100MB",
    "處理檔案過程發生錯誤:": "處理檔案過程發生錯誤:",
    "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒": "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
  },
  en: {
    "首頁": "Home Page",
    "教職員工借用職務宿舍申請表": "Application Form for Faculty and Staff Dormitory Rental",
    "流程圖": "Process Flowchart",
    "申請宿舍類別（單選）": "Dormitory Type (Single Choice)",
    "多房間職務宿舍": "Multi-Room Dormitory",
    "（水、電及瓦斯等自付）": "(Water, Electricity, and Gas are paid separately by the resident)",
    "元/月": "NT$/month",
    "保證金": "Security Deposit",
    "元": "NT$",
    "單房間職務宿舍": "Single-Room Dormitory",
    "（應付水電1,512元/月）": "(Water and Electricity: NT$ 1,512 per month)",
    "（請參閱本校教職員工宿舍分配要點）": "(Please refer to NCCU Regulations Governing the Allocation of Dormitories for Faculty and Staff)",
    "名稱": "Department",
    "請輸入名稱": "Please enter your department name",
    "到校日": "Date of Employment",
    "請輸入到校日": "Please enter your date of employment",
    "電話": "Phone Number",
    "請輸入電話": "Please enter your phone number",
    "員工代號": "Faculty/Staff ID number",
    "請輸入員工代號": "Please enter your faculty/staff ID number",
    "職稱": "Position Title",
    "請輸入職稱": "Please enter your position title",
    "兼任本校行政主管職層級": "Concurrent Administrative Supervisor Role at NCCU",
    "請輸入兼任本校行政主管職層級": "Please enter your concurrent administrative supervisor role at NCCU",
    "申請人": "Applicant",
    "姓名": "Full Name",
    "請輸入姓名": "Please enter your full name",
    "身分證號碼或護照": "National ID Number or Passport Number",
    "請輸入身分證號碼或護照": "Please enter your national ID number or passport number",
    "性別": "Gender",
    "男": "Male",
    "女": "Female",
    "出生年月日": "Date of Birth",
    "請輸入出生年月日": "Please enter your date of birth",
    "職務": "Position Title",
    "請輸入職務": "Please enter your position title",
    "中華民國身心障礙手冊": "Disability ID issued by the Republic of China (Taiwan)",
    "(已上傳, 可更新)": "Uploaded, updates allowed",
    "上傳檔案": "File Upload",
    "支援格式": "Supported formats: ZIP, RAR, 7Z, BMP, JPG, GIF, TIF, PNG, JPEG, ODT, DOC, DOCX, PDF, TXT",
    "檔案大小限制": "File size limit: 100MB",
    "自有住宅狀況": "Residential Property Ownership Status",
    "自有住宅": "Residential Property Ownership",
    "有": "Yes",
    "無": "No",
    "本人或配偶已有自有住宅或自申請分配宿舍之日起，逆算至最近3年內曾有屬於其本人或配偶所有之房屋買賣或贈與紀錄者。": "The applicant or their spouse currently owns a residential property, or has a record of a sale, purchase, or gift of a residential property owned by the applicant or their spouse within the three-year period prior to the date of this application.",
    "是": "Yes",
    "否": "No",
    "戶籍地址": "Household Registration Address",
    "請輸入戶籍地址": "Please enter your household registration address",
    "全戶戶籍謄本上傳": "Please upload the full household registration transcript",
    "隨居任所者親屬資料（申請單房間者免填）": "Information for Co-residing Family Members (Not for single-room applicants)",
    "稱謂": "Relationship",
    "身分證統一編號": "National ID Number",
    "職業及服務單位": "Occupation and Company",
    "新增": "Add",
    "請輸入稱謂": "Please enter the relationship",
    "請輸入身分證統一編號": "Please enter national ID number",
    "請輸入職業及服務單位": "Please enter occupation and company",
    "刪除": "Delete",
    "職務上有迫切需要": "Urgent Need Due to Job Duties",
    "服務單位主管副署": "Endorsement by the Department Head",
    "申請人具結聲明": "Applicant's Declaration",
    "本人具結自申請日前，本人及配偶絕無經政府輔購（建）住宅或貸款，並保證借住期間，絕對遵守學校規定、不轉借、不轉租、不空置，並保持環境之整潔、安寧與秩序，如違反上述規定，願負一切法律責任，並立即交還宿舍": "I hereby declare that, prior to the date of this application, neither I nor my spouse has ever owned government-subsidized housing or housing loans. I also guarantee that during the period of residence, I will strictly comply with all NCCU regulations, will not sublet, transfer, or leave the dormitory vacant, and will maintain cleanliness, peace, and order in the premises. Should I violate any of the above regulations, I am willing to bear all legal responsibilities and immediately return the dormitory.",
    "送出": "Submit",
    "請先登入帳號": "Please log in first",
    "請稍候...": "Please wait while we process",
    "錯誤": "Error",
    "確定": "Confirm",
    "Email格式錯誤": "Invalid Email Format",
    "數字不可小於0": "Number cannot be less than 0",
    "請選擇申請宿舍類別": "Please select the dormitory type",
    "請選擇性別": "Please select the gender",
    "請選擇自有住宅狀況": "Please select the residential property ownership status",
    "請上傳服務單位主管副署": "Please upload the endorsement by the department head",
    "儲存成功": "Sucessfully saved",
    "檔案大小超過100MB": "The size of file is over 100 MB",
    "處理檔案過程發生錯誤:": "An error occurs while processing the file:",
    "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒": "If this problem persists, please contact system support staff. We apologize for any inconvenience caused by the system error.",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Apply_1",
  i18n,
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      ApplyData: {},
      ResidentRelativeInfos: [],
      local: "zh_tw",
      instructions_check: false,
      scrolledToBottom: false,
    };
  },
  beforeCreate: function () {
    if (!$cookies.isKey("dormitory_login_token")) {
      Swal.fire({
        title: this.$t("請先登入帳號"),
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "Home",
          });
        },
      });
      return;
    }
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Apply",
        {
          params: { AId: this.$route.params.AId, Type: 1, token: $cookies.get("dormitory_login_token") },
        }
      )
      .then((response) => {
        this.ApplyData = response.data;
        if (!this.ApplyData.Apply) {
          if (this.ApplyData.Error) {
            Swal.fire({
              title: this.ApplyData.Error,
              icon: "info",
              allowOutsideClick: false,
              heightAuto: false,
              willClose: () => {
                this.$router.push({
                  name: this.ApplyData.RouterName,
                });
              },
            });
          } else {
            this.$router.push({
              name: "Home",
            });
          }
        }
        this.ResidentRelativeInfos = this.ApplyData.ResidentRelativeInfos;
        if (this.ApplyData.Apply.T1_UnitArrivalDate && this.ApplyData.Apply.T1_UnitArrivalDate != "0001-01-01T00:00:00") {
          this.ApplyData.Apply.T1_UnitArrivalDate = this.convertDatetimeString(this.ApplyData.Apply.T1_UnitArrivalDate, "YYYY-MM-DD")
        } else {
          this.ApplyData.Apply.T1_UnitArrivalDate = "";
        }
        //if (this.ApplyData.Apply.T1_ApplicantBirthDate && this.ApplyData.Apply.T1_ApplicantBirthDate != "0001-01-01T00:00:00") {
        //  this.ApplyData.Apply.T1_ApplicantBirthDate = this.convertDatetimeString(this.ApplyData.Apply.T1_ApplicantBirthDate, "YYYY-MM-DD")
        //} else {
        //  this.ApplyData.Apply.T1_ApplicantBirthDate = "";
        //}
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    send() {
      if (((this.local == 'zh_tw' && this.ApplyData.apply_1_need_tw) || (this.local == 'en' && this.ApplyData.apply_1_need_en))) {
        if (!this.scrolledToBottom) {
          Swal.fire({
            title: this.$t("錯誤"),
            text: this.$t("請將需知內容滾動至底部後，再勾選「我已閱讀條款」"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
        if (!this.instructions_check) {
          Swal.fire({
            title: this.$t("錯誤"),
            text: this.$t("請詳細閱讀需知並勾選「我已閱讀條款」"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      }
      Swal.fire({
        title: this.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      var hasError = false;
      let that = this;
      $(".form_1").find("[data-required='1']").each(function () {
        var input = $(this);
        if (!input.val() || input.val() == '-1') {
          Swal.fire({
            title: that.$t("錯誤"),
            text: input.data("required-msg"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
            willClose: () => {
              //input.focus();
            },
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "email" &&
          !Validate.reg_email(input.val())) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("Email格式錯誤"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "number" &&
          input.val() < 0) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("數字不可小於0"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      });
      if (that.ApplyData.Apply.T1_SLId == -1) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇申請宿舍類別"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (!that.ApplyData.Apply.T1_ApplicantGender) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇性別"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (that.ApplyData.Apply.T1_OwnHouse == -1 ||
        that.ApplyData.Apply.T1_OwnHouseSpouse == -1
      ) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇自有住宅狀況"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (that.ApplyData.Apply.T1_UrgentJobNeed && !that.ApplyData.Apply.T1_UnitSupervisorSignature) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請上傳服務單位主管副署"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (hasError) {
        return;
      }
      // 儲存檔案名稱
      var AttachmentNames = "{";
      $("[data-namgtag='1']").each(function () {
        if (AttachmentNames.length > 1) { AttachmentNames += ", "; }
        var input = $(this);
        AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
      });
      AttachmentNames += "}";
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/Apply",
        type: "post",
        data: {
          ApplyJson: JSON.stringify(that.ApplyData.Apply),
          AttachmentNames: AttachmentNames,
          ResidentRelativeInfos: JSON.stringify(that.ResidentRelativeInfos),
          lang: that.local,
          token: $cookies.get("dormitory_login_token")
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            Swal.fire({
              title: that.$t("填寫完成"),
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: that.$t("返回首頁"),
              heightAuto: false,
              willClose: () => {
                that.$router.push({
                  name: "Home"
                });
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: that.$t("錯誤"),
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              heightAuto: false,
            });
          }
        }
      });
    },
    showPhoto() {
      $('.form .box_bg .process_box').slideToggle("slow");
      $(".form .box_bg .title_box .open_btn").toggleClass("add");
    },
    addResidentRelativeInfo() {
      this.ResidentRelativeInfos.push({
        Title: '',
        Name: '',
        BirthDate: '',
        IDNumber: '',
        OccupationAndUnit: '',
      });
    },
    removeResidentRelativeInfo(index) {
      this.ResidentRelativeInfos.splice(index, 1);
    },
    checkFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: that.$t("請稍候..."),
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 104857600) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("檔案大小超過100MB"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            if (id == "T1_DisabilityCertificate") {
              that.ApplyData.Apply.T1_DisabilityCertificate = reader.result;
            } else if (id == "T1_ResidentCopy") {
              that.ApplyData.Apply.T1_ResidentCopy = reader.result;
            } else if (id == "T1_UnitSupervisorSignature") {
              that.ApplyData.Apply.T1_UnitSupervisorSignature = reader.result;
            }
            $("#" + id + "_data").val(reader.result);
            $("#" + id + "_name").val(file.name);
            //$("#" + id).val('');
            Swal.close();
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: that.$t("錯誤"),
              html:
                that.$t("處理檔案過程發生錯誤:") + "<br />" +
                error +
                "<br />" + that.$t("若持續發生此問題請聯繫客服人員, 造成不便敬請見諒"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    numberToCurrencyNo(value) {
      if (!value) return 0
      const intPart = Math.trunc(value)
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      let floatPart = ''
      const valueArray = value.toString().split('.')
      if (valueArray.length === 2) {
        floatPart = valueArray[1].toString()
        return intPartFormat + '.' + floatPart
      }
      return intPartFormat + floatPart
    },
    handleScroll(event) {
      const element = event.target;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      // 檢查是否滾動到底部（允許2px的容差）
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        this.scrolledToBottom = true;
      }
    }
  },
};
</script>

<style scoped>
.instructions-content {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar {
  width: 8px;
}

.instructions-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.instructions-checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  width: 100%;
}

.instructions_check {
  display: inline-flex;
  gap: 8px;
}

.instructions_check input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.instructions_check input[type="checkbox"]:disabled+label {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
